import { MutationTree } from 'vuex';
import { IdealProfileState, IdealProfile } from './ideal-profile-types';

export const mutations: MutationTree<IdealProfileState> = {
  setIdealProfileInState(state, payload: IdealProfile) {
    state.error = false;
    state.idealProfile = payload;
  },
  profileError(state) {
    state.error = true;
    state.idealProfile = undefined;
  },
};
